import React, { memo } from 'react';
import '../index.less';
import Verify from '../slideVerifyNew';
import { aliyunSlideProps } from '@/components/Login/typings';
import HeadBtn from '../components/headBtn';

interface BindingPhoneProps {
  setCurrent: (val: number) => void;
  backChange: () => void;
  slideChange: (params: aliyunSlideProps) => void;
}

function LoginVerify(props: BindingPhoneProps) {
  const { setCurrent, backChange, slideChange } = props;
  const onGoBackPage = () => {
    setCurrent(0);
  };
  return (
    <div className="main_position_box">
      <HeadBtn headBtnType={4} onGoBackPage={onGoBackPage}></HeadBtn>
      <div className="login-switch_mold" style={{ marginBottom: '0' }}>
        <div className="currnt_f">安全验证</div>
      </div>
      <div className="login-tips_hint" style={{ marginBottom: '0' }}>
        为确保是本人操作，请完成以下验证
      </div>
      <div className="login-verify_box">
        <Verify backChange={backChange} slideChange={slideChange} registerStatus={2}></Verify>
      </div>
    </div>
  );
}
export default memo(LoginVerify);
